"use client";

import { useTranslations } from "next-intl";
import { CustomScroll } from "@/components/CustomScroll";
import { useIsMobile } from "@/features/layout/useIsMobile";
import { SecondaryLayers } from "@/features/layers/components/SecondaryLayers";
import {
  toggleableLayerCount,
  useSecondaryLayers,
} from "@/features/layers/useSecondaryLayers";
import { cn } from "@/lib/cn";

/**
 * Whether this project has overlays the visitor can actually switch.
 *
 * A project can carry plenty of secondary layers and allow none of them to be
 * toggled — they are scenery the map always shows. The tab would then be a list
 * of names beside controls that refuse to move.
 */
export function useHasLayers(): boolean {
  const { sections } = useSecondaryLayers();

  return toggleableLayerCount(sections) > 0;
}

/** The overlays panel: sections of layers the visitor can show or hide. */
export function LayersTab() {
  const t = useTranslations();
  const isMobile = useIsMobile();

  return (
    <CustomScroll className={cn("mb-4 ml-5 mr-5 mt-6", isMobile && "max-h-[60vh]")}>
      <div className="mr-4">
        <span
          className={cn(
            "flex py-4 font-semibold text-black dark:text-off-white",
            isMobile ? "text-base" : "justify-center text-sm"
          )}
        >
          {t("secondaryLayer.title")}
        </span>

        <SecondaryLayers />
      </div>
    </CustomScroll>
  );
}
